import script from "./DesktopBettingSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesktopBettingSection.vue?vue&type=script&setup=true&lang=ts"

import "./DesktopBettingSection.vue?vue&type=style&index=0&id=3d7d9630&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d7d9630"]])

export default __exports__